import { canUseDOM } from "replo-utils/dom/misc";

import { Env } from "./enums";

export const isLocalhost = (): boolean => {
  if (!canUseDOM) {
    return false;
  }
  // NOTE (Chance 2024-05-31): Global window should be fine for this check
  // biome-ignore lint/style/noRestrictedGlobals: allow global
  return window.location.hostname === "localhost";
};

export const getEnv = () => {
  const nodeEnv = process.env.NODE_ENV;

  if (nodeEnv === "production") {
    return Env.PRODUCTION;
  }

  return Env.DEV;
};
